/* UNBROKEN | Gift experience: keeps product-line properties in sync */
(() => {
  if (window.__unbrokenGiftingLoaded) return;
  window.__unbrokenGiftingLoaded = true;
  const rootSelector = '[data-unbroken-gifting]';
  function sync(root) {
    if (!root) return;
    const checkbox = root.querySelector('[data-ub-gift-check]');
    const panel = root.querySelector('[data-ub-gift-panel]');
    const note = root.querySelector('[data-ub-gift-note]');
    const count = root.querySelector('[data-ub-gift-count]');
    if (!checkbox || !panel || !note) return;
    const selected = checkbox.checked;
    panel.hidden = !selected;
    checkbox.setAttribute('aria-expanded', String(selected));
    note.disabled = !selected;
    if (!selected) note.value = '';
    if (count) count.textContent = note.value.length + '/180';
  }
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-ub-gift-check]')) {
      sync(event.target.closest(rootSelector));
    }
  });
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-ub-gift-note]')) {
      const root = event.target.closest(rootSelector);
      const count = root && root.querySelector('[data-ub-gift-count]');
      if (count) count.textContent = event.target.value.length + '/180';
    }
  });
  function init(scope) {
    if (scope.matches && scope.matches(rootSelector)) sync(scope);
    scope.querySelectorAll(rootSelector).forEach(sync);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
})();